import * as React from "react";
import type { SVGProps } from "react";
const SvgPencilSimpleLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 13 13"
    {...props}
  >
    <path
      fill={props.color || "#343330"}
      stroke={props.color}
      strokeWidth={0.125}
      d="M.337 8.544 8.044.837 8.001.794l.043.043a.94.94 0 0 1 1.326 0l2.793 2.793a.937.937 0 0 1 0 1.326l.044.044-.044-.044-7 7-.106.106H11.5a.438.438 0 0 1 0 .875H1A.937.937 0 0 1 .063 12V9.207a.93.93 0 0 1 .274-.663Zm3.456 3.518h.026l.018-.018 5.5-5.5.045-.044-.045-.044-2.793-2.793-.044-.045-.044.045-5.5 5.5-.018.018v2.881h2.855Zm6.163-6.225.044.044.044-.044 1.5-1.5.044-.044-.044-.044-2.792-2.793-.044-.045-.045.045-1.5 1.5L7.12 3l.044.044z"
    />
  </svg>
);
export default SvgPencilSimpleLine;
